import "../../shared/sparkle_namespace.js";

if (!Sparkle.Components.ExpandableComponent) {
  Sparkle.Components.ExpandableComponent = {
    loaded: true,
  };

  jQuery(function () {
    // Use the tallest sticky/fixed site header as the collapse scroll offset.
    function siteHeaderOffset() {
      return jQuery(".site-header-container, .page-header-wrapper")
        .toArray()
        .reduce(function (max, headerElement) {
          var header = jQuery(headerElement);
          var position = header.css("position");

          if (position === "sticky" || position === "fixed") {
            return Math.max(max, header.outerHeight() || 0);
          }

          return max;
        }, 0);
    }

    // Other legacy code uses path-like hashes (e.g. the LocationBrowser Backbone
    // router writes "#find/<slug>/focus"). Those aren't valid CSS id selectors,
    // so we must only treat the hash as an element id when it looks like one.
    function hashTargetSelector() {
      var hash = location.hash;
      if (!hash || hash.length < 2) {
        return null;
      }
      if (!/^#[A-Za-z][\w:.-]*$/.test(hash)) {
        return null;
      }
      return hash;
    }

    function openExpandableForHash() {
      var selector = hashTargetSelector();
      if (!selector) {
        return;
      }
      jQuery(selector).find(".expandable-title").addClass("expandable-open");
    }

    openExpandableForHash();

    jQuery(window).on("hashchange", openExpandableForHash);

    jQuery(document).on("click", ".expandable-title:not(.expandable-disabled)", function (e) {
      e.preventDefault();

      jQuery(this).toggleClass("expandable-open");
    });

    // Collapse the section and keep the title visible in the viewport.
    jQuery(document).on("click", ".expandable-close", function (e) {
      e.preventDefault();

      var component = jQuery(this).closest(".component");
      var title = component.find(".expandable-title").first();
      var titleOffset = title.offset();

      component.find(".expandable-title").removeClass("expandable-open");

      if (!titleOffset) {
        return;
      }

      var targetTop = Math.max(0, titleOffset.top - siteHeaderOffset());

      if (jQuery(window).scrollTop() > targetTop) {
        jQuery(window).scrollTop(targetTop);
      }
    });

    jQuery(document).on("click", ".expandable-open-all", function (e) {
      e.preventDefault();

      toggleAll(true, jQuery(this).closest(".component"));
    });

    jQuery(document).on("click", ".expandable-close-all", function (e) {
      e.preventDefault();

      toggleAll(false, jQuery(this).closest(".component"));
    });

    function toggleAll(state, component) {
      jQuery(component).find(".expandable-title:not(.expandable-disabled)").toggleClass("expandable-open", state);
      jQuery(component)
        .nextUntil(
          ":not(.component--legacy-expandable-section):not(.component--expandable-section):not(.expandable-section)",
        )
        .find(".expandable-title:not(.expandable-disabled)")
        .toggleClass("expandable-open", state);
    }
  });
}
